import React,{useEffect} from 'react'
import { useParams , useNavigate } from 'react-router';
import landingServices from '../../landingServices';
import { useAlert } from '../../../context/AlertContext';
import { CircularProgress } from '@mui/material';

function ChatbotLandingPage() {

    let { portalId } = useParams();
    const {AppAlert} = useAlert();
    const navigate = useNavigate();

    const setPortal =() =>{
        if(portalId != localStorage.portalId){
            landingServices.getPortalDetails(portalId).then(res=>{
                window.location.reload();
            }).catch(error=>{
                AppAlert("Invalid Portal Id","error");
            })
        } else {
            if(localStorage.portalUrl != undefined) {
                navigate("/chatbot")
            }
        }
    }
    useEffect(()=>{
        setPortal()
    },[])

    return (
        <div className="container">
            <div className="row mt-5">
                <div className='col-md-12 text-center'>
                    <img src='/images/ghelp-logo.png' style={{width:"30%"}} />
                </div>
                <div className="col-md-12 text-center mt-3">
                    <CircularProgress/>
                </div>
            </div>
        </div>
    )
}

export default ChatbotLandingPage